import { useEffect, useState } from "react";

const Tokens = ({
  pos,
  updatePos,
  itemCoinData,
  index,
  isConnected,
  isSignIn,isHeadOpen
}) => {
  const [coinPos, setCoinPos] = useState(itemCoinData);
  const updateCoinPos = (data) => {
    setCoinPos((coinPos) => ({ ...coinPos, ...data }));
  };
  useEffect(() => {
    let arr = [...pos.coins];
    arr[index] = coinPos;
    updatePos({ coins: arr });
  }, [coinPos]);

  useEffect(() => {
    setCoinPos(itemCoinData);
  }, [itemCoinData]);
  return (
    <div className="walletsItem__coin">
      <div className="check">
        <div className="check__row">
          <img src={process.env.PUBLIC_URL + coinPos.coinIcon} alt="coin" />
          <p>{coinPos.coin}</p>
        </div>
        <div className="checkInput">
          <input
            disabled={!isConnected || !isSignIn || !isHeadOpen}
            type="checkbox"
            checked={coinPos.status}
            onChange={(e) => updateCoinPos({ status: e.target.checked })}
          />
          <label htmlFor=""></label>
        </div>
      </div>
    </div>
  );
};
export default Tokens;
